module.exports = __webpack_public_path__ + "static/media/1.559d7f75.jpg";